import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-health-system-search-skeleton',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div role="status" aria-label="Loading healthcare providers" aria-busy="true">
      <div aria-hidden="true">
        <div *ngIf="showControls" class="flex items-end gap-2">
          <div class="skeleton h-12 flex-1"></div>
          <div class="skeleton h-12 w-12"></div>
        </div>
        <div class="space-y-2" [class.mt-fdk-m]="showControls">
          <div *ngFor="let row of [0, 1]" class="skeleton-card">
            <div class="skeleton skeleton-circle"></div>
            <div class="flex-1 space-y-1">
              <div class="skeleton skeleton-text w-32"></div>
            </div>
            <div class="skeleton w-5 h-5 rounded"></div>
          </div>
        </div>
      </div>
      <span class="sr-only">Loading healthcare providers</span>
    </div>
  `,
})
export class HealthSystemSearchSkeletonComponent {
  @Input() showControls = true;
}
